var _circle, _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconShiflowLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 34,
    height: 34,
    viewBox: "0 0 34 34",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 16.7296,
    cy: 16.7296,
    r: 16.7296,
    fill: "white"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M23.4653 19.5004C20.9861 19.5004 18.6432 18.3601 16.9398 17.2405L16.793 17.1425C10.0787 12.8343 6.81334 17.0032 6.67707 17.1837C6.46217 17.4675 6.05334 17.5294 5.76506 17.3179C5.47678 17.1063 5.41388 16.7091 5.62354 16.4201C5.66547 16.3634 6.69279 15.0013 8.71598 14.3099C12.039 13.1748 15.4145 14.6968 17.6631 16.1725L17.8098 16.2705C24.5241 20.5839 27.7895 16.415 27.9258 16.2344C28.1407 15.9506 28.5495 15.8887 28.8378 16.1002C29.1261 16.3118 29.189 16.7091 28.9793 16.998C28.9374 17.0547 27.9101 18.4169 25.8869 19.1082C25.0797 19.3817 24.2673 19.5004 23.4653 19.5004Z",
    fill: "#14151B"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M18.1084 20.4807C17.0444 20.4807 15.8756 20.1866 14.7277 19.3766C11.9026 17.385 8.87826 19.7119 8.75247 19.8151C8.46943 20.037 8.0606 19.9905 7.83522 19.7171C7.60984 19.4385 7.65177 19.036 7.93481 18.8142C9.27137 17.7461 12.5735 16.2757 15.4877 18.3292C18.3285 20.3311 20.9964 18.2363 21.0226 18.2157C21.3004 17.9886 21.7145 18.0299 21.9399 18.3085C22.1705 18.582 22.1286 18.9896 21.8455 19.2114C21.1327 19.7893 19.7385 20.4807 18.1084 20.4807Z",
    fill: "#14151B"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M22.3594 16.1208C21.3059 16.1208 20.1842 15.8422 19.1202 15.0889C16.3003 13.1025 13.6901 15.1199 13.58 15.2076C13.297 15.4295 12.8882 15.3882 12.6628 15.1096C12.4374 14.8361 12.4793 14.4285 12.7571 14.2067C13.9469 13.2521 16.966 11.9881 19.8802 14.0416C22.7211 16.0434 25.824 13.6288 25.8554 13.6082C26.1385 13.3863 26.5473 13.4276 26.7727 13.7062C26.9981 13.9848 26.9561 14.3872 26.6731 14.6091C25.8292 15.285 24.1887 16.1208 22.3594 16.1208Z",
    fill: "#14151B"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconShiflowLogo);
export default __webpack_public_path__ + "static/media/icon-shiflow-logo.87216c51668b5643b50af2e60086e0eb.svg";
export { ForwardRef as ReactComponent };